export default __webpack_public_path__ + "static/media/Twice big 7.fec3e4b4.jpg";